export default "__VITE_ASSET__DqTV82zQ__"